import React from 'react'
import { Link } from 'react-router-dom'
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, Download } from 'lucide-react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer" id="contacto">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-column">
            <h3>Checkin24</h3>
            <p>Checkin24 disponible cuando tú lo necesites</p>
            <div className="contact-info">
              <div className="contact-item">
                <Mail size={16} />
                <span>checkin24.sv@gmail.com</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span>+503 7951 4601</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Pasaje San José, Casa #5, San Salvador</span>
              </div>
            </div>
          </div>
          
          {/* Navigation Links */}
          <div className="footer-column">
            <h4>Navegación</h4>
            <ul className="footer-links">
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/habitaciones">Habitaciones</Link></li>
            </ul>
          </div>
          
          {/* Highlights */}
          <div className="footer-column">
            <h4>Servicios</h4>
            <ul className="footer-links">
              <li><Link to="/#">Reservas Online</Link></li>
              <li><Link to="/#">Cancelaciones</Link></li>
            </ul>
          </div>
          
          {/* Agents & Agencies */}
          {/* <div className="footer-column">
            <h4>Para Propietarios</h4>
            <ul className="footer-links">
              <li><Link to="/registrar-propiedad">Registrar Propiedad</Link></li>
              <li><Link to="/panel-propietario">Panel de Control</Link></li>
            </ul>
          </div> */}
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="legal-links">
              <Link to="/privacidad">Política de Privacidad</Link>
              <Link to="/terminos">Términos de Servicio</Link>
              <Link to="/cookies">Política de Cookies</Link>
            </div>
            
            <div className="social-icons">
              <a href="#" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} Checkin24. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer